import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-organisation-users',
  templateUrl: './organisation-users.component.html',
  styleUrls: ['./organisation-users.component.scss'],
})
export class OrganisationUsersComponent {}
